import { AtivoMonitoramentoDetalhado } from './ativo-monitoramento-detalhado.model copy';
import { ItemMonitoramentoDetalhado } from './item-monitoramento-detalhado.model';
import { ItemMonitoramento } from './item-monitoramento.model';

export class StorageMonitoramento {

  tipo: TipoStorage;
  nome: String;
  leitura: ItemMonitoramento;
  escrita: ItemMonitoramento;
  exclusao: ItemMonitoramento;

  public static getAtivo(storage: StorageMonitoramento): AtivoMonitoramentoDetalhado {
    return new AtivoMonitoramentoDetalhado('Storage - ' + storage.nome, [
      new ItemMonitoramentoDetalhado('Leitura', storage.leitura),
      new ItemMonitoramentoDetalhado('Escrita', storage.escrita),
      new ItemMonitoramentoDetalhado('Exclusão', storage.exclusao),
    ]);
  }
}

export enum TipoStorage {
  S3 = 'S3',
  JCR = 'JCR',
  MINIO = 'MINIO',
  OUTRO = 'OUTRO'
}
